import logger from 'loglevel';

switch (process.env.ENV_MODE) {
  case 'production': {
    logger.setLevel('error');
    break;
  }
  case 'development': {
    logger.setLevel('debug');
    break;
  }
  default: {
    logger.setLevel('info');
  }
}
export default logger;
